import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ShoppingCartIcon,
  WalletIcon,
} from "../../../../../../assets/icons/svgicons";
import verifyKyc from "../../../../../../assets/images/verify-kyc.png";
import {
  getUserInfoAction,
  setUserKyc,
} from "../../../../../../features/user/userSlice";
import Button from "../../../../../common/Button/Button";
import Card from "../../../../../common/Card/Card";
import AccountActivated from "../../../../../common/Modals/AccountActivated/AccountActivated";
import styles from "./VerifyKyc.module.scss";
import { Veriff } from "@veriff/js-sdk";
import { createVeriffFrame, MESSAGES } from "@veriff/incontext-sdk";
import { VERIFF_KEY } from "../../../../../../utils/constants";
const VerifyKyc = () => {
  const kycStatus = useSelector(
    (state) => state?.persist?.userInfo?.kyc_status
  );
  const userInfo = useSelector((state) => state?.persist?.userInfo);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const apiKey = VERIFF_KEY;

  const veriff = Veriff({

    host: "https://stationapi.veriff.com",
    apiKey: apiKey,
    parentId: "veriff-root",
    onSession: function (err, response) {
      if (err) {
        console.error("Veriff Session Error:", err);
        return;
      }
      
      const url =
        sessionStorage.getItem("@veriff-session-url") ||
        response?.verification?.url || 
        process.env.REACT_APP_URL1;

      if (!url) {
        console.error("No Veriff URL found.");
        return;
      }

      createVeriffFrame({
        url: url,
        onEvent: async function (msg) {
          if (msg === "FINISHED") {
            await dispatch(getUserInfoAction());
          }
        },
        onReload: () => {
          console.warn("Veriff frame requested reload - suppressed to prevent page refresh.");
          // window.location.reload(); 
        },
      });
    },

  });

  useEffect(() => {
    if (kycStatus === "PENDING" || kycStatus === "REJECTED") {
      veriff.setParams({
        person: {
          givenName: " ",
          lastName: " ",
        },
        vendorData: userInfo?.user_uid,
      });
      
      veriff.mount({
        submitBtnText: "Verify",
        loadingText: "Please wait...",
      });

      const protectForm = () => {
        const veriffForm = document.querySelector("form[name='veriff-form']");
        
        if (veriffForm && !document.getElementById("veriff-iframe-target")) {
          // 1. Create a hidden iframe
          const iframe = document.createElement("iframe");
          iframe.id = "veriff-iframe-target";
          iframe.name = "veriff-iframe-target";
          iframe.style.display = "none";
          document.body.appendChild(iframe);

          // 2. Point the form to the hidden iframe
          // This allows the SDK to "submit" without refreshing the main window
          veriffForm.target = "veriff-iframe-target";
        }
        
        return !!veriffForm;
      };

      // Try once immediately
      protectForm();

      const observer = new MutationObserver(() => {
        protectForm();
      });

      const target = document.getElementById("veriff-root");
      if (target) {
        observer.observe(target, { childList: true, subtree: true });
      }

      return () => {
        observer.disconnect();
        const iframe = document.getElementById("veriff-iframe-target");
        if (iframe) iframe.remove();
      };

    }
  }, []);

  return (

    <>
      {/* <Card
        title="Portfolio Balance"
        className={styles.verify_kyc}
        bodyClassName={styles.verify_kyc_body}
      > */}
      <div className={styles.verify_kyc}>
        <div className={styles.verify_kyc_left}>
          {kycStatus === "SUBMITTED" ? (
            <>
              <h2>
                KYC Verification Status: <br /> Currently in Progress
              </h2>
              <ul className={styles.progress_status}>
                <li>
                  <p>
                    Thank you for submitting your KYC documents. It may take up
                    to 24 hours for verification. We'll keep you updated on the
                    progress and we will notify you by email when its completed.
                  </p>
                </li>
              </ul>
              <Button
                onClick={() => {
                  setShow(true);
                }}
                disabled
                variant="bordered_blue"
                className={styles.verify_btn}
                fluid
              >
                Check your email
              </Button>
            </>
          ) : kycStatus === "PENDING" ? (
            <>
              <h2>Complete KYC verification to access all STBL services.</h2>
              <ul>
                <li>
                  <span>
                    <WalletIcon />
                  </span>{" "}
                  <p>Your wallet will be activated after KYC verification.</p>
                </li>
                <li>
                  <span>
                    <ShoppingCartIcon />
                  </span>{" "}
                  <p>You can purchase the stablecoin after KYC verification.</p>
                </li>
              </ul>
              {/* <Button
                onClick={() => dispatch(setUserKyc("in-progress"))}
                className={styles.verify_btn}
                fluid
              >
                Verify
              </Button> */}
              <div id="veriff-root" className={styles.verify_root}></div>
            </>
          ) : kycStatus === "REJECTED" ? (
            <>
              <h2>
                Your KYC has been rejected by Admin. Please submit your KYC
                again.
              </h2>
              <ul>
                <li>
                  <span>
                    <WalletIcon />
                  </span>{" "}
                  <p>Your wallet will be activated after KYC verification.</p>
                </li>
                <li>
                  <span>
                    <ShoppingCartIcon />
                  </span>{" "}
                  <p>You can purchase the stablecoin after KYC verification.</p>
                </li>
              </ul>
              {/* <Button
                onClick={() => dispatch(setUserKyc("in-progress"))}
                className={styles.verify_btn}
                fluid
              >
                Verify
              </Button> */}
              <div id="veriff-root" className={styles.verify_root}></div>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className={styles.verify_kyc_right}>
          <img src={verifyKyc} alt="verify-kyc" />
        </div>
      </div>
      {/* </Card> */}
      <AccountActivated show={show} handleClose={() => setShow(false)} />
    </>
  );
};

export default VerifyKyc;